import { PartnierComponent } from './partnier/partnier.component';
import { AboutComponent } from './about.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CoreModule } from '../share/core.module';

const routes: Routes = [
  { path: "", component: AboutComponent }
]

@NgModule({
  declarations: [
    AboutComponent,
    PartnierComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CoreModule
  ],
  exports: [
    RouterModule
  ]
})
export class AboutModule { 
}
